// extracted by mini-css-extract-plugin
module.exports = {"spinner":"CircleSpinner_spinner__FgyY9"};